export default __webpack_public_path__ + "static/Plots0081-b5b0341d95dba61b62280bbeaf1aa11d.jpg";